import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor() {
  
  }

  private _lang: string;

  get lang(): string {
    return this._lang;
  }

  set lang(value: string) {
    this._lang = value;
    localStorage.setItem('lang', value);
    // window.location.reload()
  }


  public get({key}: { key: string }): Promise<string> {
    return new Promise(resolve => {
      resolve(window.localStorage.getItem(key));
    });
  }

  public set({key, value}: { key: string; value: string }): Promise<boolean> {
    return new Promise(resolve => {
      window.localStorage.setItem(key, value);
      resolve(true);
    });
  }

  public getAsync({key}: { key: string }): string {
    return window.localStorage.getItem(key);
  }
}
